import { render } from "./TimelineNr1.vue?vue&type=template&id=1afbd10a&scoped=true"
import script from "./TimelineNr1.vue?vue&type=script&lang=js"
export * from "./TimelineNr1.vue?vue&type=script&lang=js"

import "./TimelineNr1.vue?vue&type=style&index=0&id=1afbd10a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afbd10a"]])

export default __exports__